import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { RejectReviewService } from '../../services/raintree/Transmission/reject-review.service';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DpSuccessMessageComponent } from '../../common-component/dp-success-message/dp-success-message.component';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-rejection-dialogue',
  standalone: true,
  imports: [
    MatDialogModule,
    MatIconModule,
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
  ],
  templateUrl: './rejection-dialogue.component.html',
  styleUrl: './rejection-dialogue.component.scss',
})
export class RejectionDialogueComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public memkey: any,
    private rejectService: RejectReviewService,
    private dialog: MatDialog,
    public toaster: ToastrService,
    private route: ActivatedRoute,
    private dialogRef: MatDialogRef<RejectionDialogueComponent>
  ) {}
  public othersClicked: boolean = false;
  public memName: boolean = false;
  public insuffAdd: boolean = false;
  public wPin: boolean = false;
  public wIVdate: boolean = false;
  public wAddress: boolean = false;
  public wEmail: boolean = false;
  public isLoaderSpin: boolean = false;
  public rejectBTnText: string = 'Yes, Reject';

  ngOnInit(): void {
    console.log(this.memkey);
  }

  reasonForm = new FormControl();

  private rejectedReason: any = [];

  public enableCommentSec: boolean = false;

  toggleSelection(event: any) {
    console.log(event.target);

    if (event.target.checked) {
      if (event.target.value == 'Others') {
        this.othersClicked = true;
        this.otherClick();
      }
      if (event.target.value == 'Member name & philanthropy name mismatch') {
        this.memName = true;
        this.rejectedReason.push(event.target.value);
      }
      if (event.target.value == 'Insufficient address details') {
        this.insuffAdd = !this.insuffAdd;
        this.rejectedReason.push(event.target.value);
      }
      if (event.target.value == 'Wrong PIN code') {
        this.wPin = !this.wPin;
        this.rejectedReason.push(event.target.value);
      }
      if (event.target.value == 'Outdated last istavrity date') {
        this.wIVdate = !this.wIVdate;
        this.rejectedReason.push(event.target.value);
      }
      if (event.target.value == 'Incorrect address') {
        this.wAddress = !this.wAddress;
        this.rejectedReason.push(event.target.value);
      }
      if (event.target.value == 'Incorrect email address') {
        this.wEmail = !this.wEmail;
        this.rejectedReason.push(event.target.value);
      }
    } else {
      let index: number = this.rejectedReason.findIndex(
        (x: any) => x == event.target.value
      );
      console.log(index);

      if (index > -1) {
        this.rejectedReason.splice(index, 1);
        if (event.target.value == 'Others') {
          this.othersClicked = false;
          this.otherClick();
        }

        if (event.target.value == 'Member name & philanthropy name mismatch') {
          this.memName = false;
        }
        if (event.target.value == 'Insufficient address details') {
          this.insuffAdd = false;
        }
        if (event.target.value == 'Wrong PIN code') {
          this.wPin = false;
        }
        if (event.target.value == 'Outdated last istavrity date') {
          this.wIVdate = false;
        }
        if (event.target.value == 'Incorrect address') {
          this.wAddress = false;
        }
        if (event.target.value == 'Incorrect email address') {
          this.wEmail = false;
        }
      }

      if (event.target.value == 'Others') {
        this.othersClicked = false;
        this.otherClick();
      }
    }
  }

  otherClick() {
    this.enableCommentSec = !this.enableCommentSec;
    this.reasonForm.setValue(null);
  }

  acceptRejection() {
    this.isLoaderSpin = true;
    this.rejectBTnText = '';
    this.rejectedReason.push(this.reasonForm.value);

    console.log(this.rejectedReason);

    let AllNull = this.rejectedReason.every((item: any) => item === null);

    if (AllNull) {
      this.rejectBTnText = 'Yes, Reject';
      this.isLoaderSpin = false;
      this.toaster.error('Enter Valid rejection reason');
      return;
    }
    let stateName: any = '';
    let districtName: any = '';
    const queryParams: any = { ...this.route.snapshot.queryParams };
    let bodyObj = {
      approved: false,
      rejected: true,
      uiState: queryParams['state'],
      uiDistrict: queryParams['district'],
      rejectedReason: this.rejectedReason.join(','),
    };

    console.log(bodyObj);

    this.rejectService.rejectMemdata(this.memkey, bodyObj).subscribe({
      next: (response) => {
        console.log(response);
        this.isLoaderSpin = false;
        this.rejectBTnText = 'Yes, Reject';
        this.dialog.open(DpSuccessMessageComponent, {
          panelClass: 'common-pannel-dialog-container',
          data: {
            mainHeading: `Data rejected successfully!`,
            subHeading: '',
            buttonValue: 'Done',
            reload: true,
          },
        });
        this.dialogRef.close(true);
      },
      error: (error) => {
        this.isLoaderSpin = false;
        this.rejectBTnText = 'Yes, Reject';
        console.log(error);
      },
    });
  }
}
